export default __webpack_public_path__ + "static/media/image7.f4e9d759.png";